import{a as e}from"./ids-chunk-A57CAC7H.js";import{a as l}from"./ids-chunk-U4K5B3VN.js";import{a as c}from"./ids-chunk-6QMEC4B7.js";import{a as o,b as s}from"./ids-chunk-XE4WFW5M.js";import{a as d}from"./ids-chunk-W3LDHTW6.js";import{e as n}from"./ids-chunk-Y6KVKFJX.js";import{a as t}from"./ids-chunk-TFRXZ5TN.js";import{a as i}from"./ids-chunk-ZMMCFAAI.js";var m=`/* Ids Separator Component */
:host {
  display: block;
}

:host([hidden]) {
  visibility: hidden;
}

:host([vertical]) {
  justify-self: center;
  align-self: center;
}

.ids-separator {
  background-color: var(--ids-separator-color-background);
  display: block;
  list-style: none;
}
.ids-separator:not(.vertical) {
  height: var(--ids-separator-width);
}
.ids-separator:not(.vertical):not(.no-margins) {
  margin-block-start: var(--ids-separator-margin);
  margin-block-end: var(--ids-separator-margin);
}
.ids-separator.vertical {
  width: var(--ids-separator-width);
  height: var(--ids-separator-height);
}
.ids-separator.vertical:not(.no-margins) {
  margin-inline-start: var(--ids-separator-margin);
  margin-inline-end: var(--ids-separator-margin);
}
.ids-separator.color-variant-alternate-formatter.vertical {
  align-self: center;
  background-color: var(--ids-separator-alternate-color-background);
  height: var(--ids-space-sm);
}
.ids-separator.color-variant-module-nav {
  background-color: var(--ids-module-nav-separator-color);
}
.ids-separator.color-variant-module-nav:not(.no-margins) {
  margin-inline: var(--ids-module-nav-separator-expanded-edge-distance);
}`;var p=c(l(d)),a=class extends p{constructor(){super()}connectedCallback(){super.connectedCallback(),this.vertical=this.vertical}static get attributes(){return[...super.attributes,t.VERTICAL,t.NO_MARGINS]}colorVariants=["alternate-formatter","module-nav"];template(){let r="div";return this.parentElement?.tagName==="IDS-MENU-GROUP"&&(r="li"),`<${r} part="separator" class="ids-separator${this.vertical?" vertical":""}${this.noMargins?" no-margins":""}"></${r}>`}set vertical(r){e(t.VERTICAL,this,r)}get vertical(){return n(this.getAttribute(t.VERTICAL))}set noMargins(r){e(t.NO_MARGINS,this,r)}get noMargins(){return this.hasAttribute(t.NO_MARGINS)}};a=i([o("ids-separator"),s(m)],a);export{a};
